import React from 'react';
import './Footer.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram, faXTwitter, faYoutube, faTiktok, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { Link } from 'react-router-dom';
import logo from '../../photos/brand/logo2.svg';
import siteMeta from '../../config/siteMeta';

const quickLinks = [
  { to: '/', label: 'Home' },
  { to: '/about', label: 'About Us' },
  { to: '/projects', label: 'Projects' },
  { to: '/sponsors', label: 'Sponsors' },
  { to: '/awards', label: 'Awards' },
  { to: '/integrai', label: 'IntegrAI' },
];

const socialIcons = {
  Instagram: faInstagram,
  X: faXTwitter,
  YouTube: faYoutube,
  TikTok: faTiktok,
  LinkedIn: faLinkedin,
};

const socialLinks = siteMeta.SOCIAL_LINKS.map((link) => ({
  ...link,
  icon: socialIcons[link.platform],
}));

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer
      className="footer"
      id="contact"
      role="contentinfo"
      itemScope
      itemType="https://schema.org/WPFooter"
    >
      <div className="footer-inner" itemScope itemType="https://schema.org/Organization">
        <section className="footer-brand" aria-label="INTEGRA 3646 identity">
          <Link to="/" className="footer-logo-card" aria-label="Return to INTEGRA 3646 homepage">
            <img src={logo} alt="INTEGRA 3646 team logo" itemProp="logo" />
          </Link>
          <div>
            <meta itemProp="name" content="INTEGRA 3646" />
            <h2>INTEGRA 3646</h2>
            <p>
              FIRST Robotics Competition team from Istanbul building robotics, STEM outreach,
              public projects, and judge-facing impact work.
            </p>
          </div>
        </section>

        <nav className="footer-column" aria-labelledby="footer-explore-heading">
          <h3 id="footer-explore-heading">Explore</h3>
          <ul>
            {quickLinks.map(({ to, label }) => (
              <li key={to}>
                <Link to={to}>{label}</Link>
              </li>
            ))}
          </ul>
        </nav>

        <address className="footer-column footer-contact" aria-labelledby="footer-contact-heading">
          <h3 id="footer-contact-heading">Contact</h3>
          <a href="mailto:integra3646@gmail.com" itemProp="email" aria-label="Email INTEGRA 3646">
            integra3646@gmail.com
          </a>
          <span>Istanbul, Turkiye</span>
        </address>

        <nav className="footer-column" aria-labelledby="footer-follow-heading">
          <h3 id="footer-follow-heading">Follow</h3>
          <ul className="footer-social">
            {socialLinks.map(({ href, label, platform, icon }) => (
              <li key={platform}>
                <a
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  itemProp="sameAs"
                >
                  <FontAwesomeIcon icon={icon} aria-hidden="true" />
                  <span>{platform}</span>
                </a>
              </li>
            ))}
          </ul>
        </nav>
      </div>

      <div className="footer-bottom">
        <small itemProp="copyrightYear">&copy; {currentYear}</small>
        <small itemProp="copyrightHolder">INTEGRA 3646. All rights reserved.</small>
        <Link to="/privacy">Privacy</Link>
      </div>
    </footer>
  );
}

export default Footer;
